/**
 * @generated SignedSource<<2f5505bdfadd93967ad89b0db0e67203>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Query } from 'relay-runtime';
export type MortgageTrancheType = "fixed" | "variable";
export type SubscriptionStatus = "active" | "canceled" | "incomplete" | "incomplete_expired" | "past_due" | "trialing" | "unpaid";
export type PropertyMortgageFormDataQuery$variables = {|
  propertyId: string,
|};
export type PropertyMortgageFormDataQuery$data = {|
  +property: ?{|
    +id?: string,
    +mortgage?: ?{|
      +borrowerPropertyLocation: ?string,
      +id: string,
      +lender: ?{|
        +id: string,
        +name: ?string,
        +primaryImage: ?{|
          +url: string,
        |},
      |},
      +loanAmount: ?number,
      +mortgageBroker: ?{|
        +firstName: ?string,
        +id: string,
        +lastName: ?string,
        +organisation: ?{|
          +formattedAddress: ?string,
          +name: ?string,
        |},
        +primaryEmail: ?{|
          +email: string,
        |},
        +primaryImage: ?{|
          +url: string,
        |},
        +subscription: ?{|
          +status: SubscriptionStatus,
        |},
      |},
      +property: {|
        +financingInstitution: ?{|
          +id: string,
        |},
        +id: string,
        +lead: ?{|
          +broker: ?{|
            +firstName: ?string,
            +id: string,
            +lastName: ?string,
            +organisation: ?{|
              +formattedAddress: ?string,
              +name: ?string,
            |},
            +primaryEmail: ?{|
              +email: string,
            |},
            +primaryImage: ?{|
              +url: string,
            |},
            +subscription: ?{|
              +status: SubscriptionStatus,
            |},
          |},
          +contact: ?{|
            +firstName: ?string,
            +id: string,
            +lastName: ?string,
            +organisation: ?{|
              +formattedAddress: ?string,
              +name: ?string,
            |},
            +primaryEmail: ?{|
              +email: string,
            |},
            +primaryImage: ?{|
              +url: string,
            |},
            +subscription: ?{|
              +status: SubscriptionStatus,
            |},
          |},
          +mortgageInsuranceProvider: ?{|
            +id: string,
            +name: ?string,
            +primaryImage: ?{|
              +url: string,
            |},
          |},
          +mortgageInsuranceRevenue: ?number,
          +mortgageLender: ?{|
            +id: string,
            +name: ?string,
            +primaryImage: ?{|
              +url: string,
            |},
          |},
          +mortgageRevenue: ?number,
          +secondContact: ?{|
            +firstName: ?string,
            +id: string,
            +lastName: ?string,
            +organisation: ?{|
              +formattedAddress: ?string,
              +name: ?string,
            |},
            +primaryEmail: ?{|
              +email: string,
            |},
            +primaryImage: ?{|
              +url: string,
            |},
            +subscription: ?{|
              +status: SubscriptionStatus,
            |},
          |},
        |},
        +owners: ?$ReadOnlyArray<{|
          +firstName: ?string,
          +id: string,
          +lastName: ?string,
          +organisation: ?{|
            +formattedAddress: ?string,
            +name: ?string,
          |},
          +primaryEmail: ?{|
            +email: string,
          |},
          +primaryImage: ?{|
            +url: string,
          |},
          +subscription: ?{|
            +status: SubscriptionStatus,
          |},
        |}>,
      |},
      +signedAt: ?string,
      +totalDebt: number,
      +tranches: $ReadOnlyArray<?{|
        +expiryDate: ?string,
        +interestRate: ?number,
        +loanAmount: ?number,
        +startDate: ?string,
        +type: ?MortgageTrancheType,
      |}>,
      +value: ?number,
    |},
  |},
|};
export type PropertyMortgageFormDataQuery = {|
  response: PropertyMortgageFormDataQuery$data,
  variables: PropertyMortgageFormDataQuery$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "propertyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "propertyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryImage",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedAddress",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v12 = [
  (v2/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Email",
    "kind": "LinkedField",
    "name": "primaryEmail",
    "plural": false,
    "selections": [
      (v9/*: any*/)
    ],
    "storageKey": null
  },
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Organisation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v10/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Subscription",
    "kind": "LinkedField",
    "name": "subscription",
    "plural": false,
    "selections": [
      (v11/*: any*/)
    ],
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "borrowerPropertyLocation",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loanAmount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedAt",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "MortgageTranche",
  "kind": "LinkedField",
  "name": "tranches",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interestRate",
      "storageKey": null
    },
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiryDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mortgageRevenue",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mortgageInsuranceRevenue",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancingInstitution",
  "kind": "LinkedField",
  "name": "financingInstitution",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalDebt",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryImage",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v23 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v22/*: any*/)
],
v24 = [
  (v2/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Email",
    "kind": "LinkedField",
    "name": "primaryEmail",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      (v2/*: any*/)
    ],
    "storageKey": null
  },
  (v22/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Organisation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v10/*: any*/),
      (v2/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Subscription",
    "kind": "LinkedField",
    "name": "subscription",
    "plural": false,
    "selections": [
      (v11/*: any*/),
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertyMortgageFormDataQuery",
    "selections": [
      {
        "alias": "property",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Mortgage",
                "kind": "LinkedField",
                "name": "mortgage",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organisation",
                    "kind": "LinkedField",
                    "name": "lender",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "mortgageBroker",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Property",
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "owners",
                        "plural": true,
                        "selections": (v12/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Lead",
                        "kind": "LinkedField",
                        "name": "lead",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organisation",
                            "kind": "LinkedField",
                            "name": "mortgageInsuranceProvider",
                            "plural": false,
                            "selections": (v6/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "contact",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "secondContact",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "broker",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organisation",
                            "kind": "LinkedField",
                            "name": "mortgageLender",
                            "plural": false,
                            "selections": (v6/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Property",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PropertyMortgageFormDataQuery",
    "selections": [
      {
        "alias": "property",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Mortgage",
                "kind": "LinkedField",
                "name": "mortgage",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organisation",
                    "kind": "LinkedField",
                    "name": "lender",
                    "plural": false,
                    "selections": (v23/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "mortgageBroker",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Property",
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "owners",
                        "plural": true,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Lead",
                        "kind": "LinkedField",
                        "name": "lead",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organisation",
                            "kind": "LinkedField",
                            "name": "mortgageInsuranceProvider",
                            "plural": false,
                            "selections": (v23/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "contact",
                            "plural": false,
                            "selections": (v24/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "secondContact",
                            "plural": false,
                            "selections": (v24/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "broker",
                            "plural": false,
                            "selections": (v24/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organisation",
                            "kind": "LinkedField",
                            "name": "mortgageLender",
                            "plural": false,
                            "selections": (v23/*: any*/),
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Property",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5a3bfbf4c93e250d4a764ba46292a6af",
    "id": null,
    "metadata": {},
    "name": "PropertyMortgageFormDataQuery",
    "operationKind": "query",
    "text": "query PropertyMortgageFormDataQuery(\n  $propertyId: ID!\n) {\n  property: node(id: $propertyId) {\n    __typename\n    ... on Property {\n      id\n      mortgage {\n        id\n        lender {\n          id\n          name\n          primaryImage {\n            url\n            id\n          }\n        }\n        mortgageBroker {\n          id\n          firstName\n          lastName\n          primaryEmail {\n            email\n            id\n          }\n          primaryImage {\n            url\n            id\n          }\n          organisation {\n            name\n            formattedAddress\n            id\n          }\n          subscription {\n            status\n            id\n          }\n        }\n        borrowerPropertyLocation\n        loanAmount\n        value\n        signedAt\n        tranches {\n          interestRate\n          loanAmount\n          type\n          startDate\n          expiryDate\n        }\n        property {\n          id\n          owners {\n            id\n            firstName\n            lastName\n            primaryEmail {\n              email\n              id\n            }\n            primaryImage {\n              url\n              id\n            }\n            organisation {\n              name\n              formattedAddress\n              id\n            }\n            subscription {\n              status\n              id\n            }\n          }\n          lead {\n            mortgageRevenue\n            mortgageInsuranceRevenue\n            mortgageInsuranceProvider {\n              id\n              name\n              primaryImage {\n                url\n                id\n              }\n            }\n            contact {\n              id\n              firstName\n              lastName\n              primaryEmail {\n                email\n                id\n              }\n              primaryImage {\n                url\n                id\n              }\n              organisation {\n                name\n                formattedAddress\n                id\n              }\n              subscription {\n                status\n                id\n              }\n            }\n            secondContact {\n              id\n              firstName\n              lastName\n              primaryEmail {\n                email\n                id\n              }\n              primaryImage {\n                url\n                id\n              }\n              organisation {\n                name\n                formattedAddress\n                id\n              }\n              subscription {\n                status\n                id\n              }\n            }\n            broker {\n              id\n              firstName\n              lastName\n              primaryEmail {\n                email\n                id\n              }\n              primaryImage {\n                url\n                id\n              }\n              organisation {\n                name\n                formattedAddress\n                id\n              }\n              subscription {\n                status\n                id\n              }\n            }\n            mortgageLender {\n              id\n              name\n              primaryImage {\n                url\n                id\n              }\n            }\n            id\n          }\n          financingInstitution {\n            id\n          }\n        }\n        totalDebt\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "4372acb3aa036f2c253ff4e10488ab28";

export default node;
